export default {
  getMessage: (field, args) => {
    return 'O valor não confere com o campo ' + args[1]
  },
  validate: (value, [fieldValue]) => {
    return value === fieldValue
  }
}



// WEBPACK FOOTER //
// ./src/validators/equals.js